import CryptoJS from 'crypto-js'

export const useEncrypt = () => {
  const encryptPhrase = (phrase: string) => {
    const key = CryptoJS.enc.Utf8.parse(process.env.REACT_APP_KEY_PHRASE || '')
    const encryptedData = CryptoJS.AES.encrypt(phrase, key, {
      mode: CryptoJS.mode.ECB,
    })
    return encryptedData.toString()
  }

  return { encryptPhrase }
}
